export default "__VITE_ASSET__BF3CqFb3__"